module.exports = __webpack_public_path__ + "img/green-title.79a6b04e.png";